import { useQuery } from "@tanstack/react-query";

import { ClinicsApi } from "../api/clinicsApi";

export const ClinicsQueryKeys = {
  all: ["clinics"] as const,
  list: () => [...ClinicsQueryKeys.all, "list"] as const,
};

export const useClinicsQuery = () => {
  return useQuery({
    queryKey: ClinicsQueryKeys.list(),
    queryFn: () => ClinicsApi.listClinics(),
    staleTime: Infinity,
  });
};
